var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoimg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_990_1356)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.99707 2.01868L13.3243 8.01478L3.99707 14.0109V2.01868Z",
    stroke: "white",
    strokeWidth: 1.3325,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_990_1356"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.99,
    height: 15.99,
    fill: "white",
    transform: "translate(-0.000244141 0.0200195)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoimg);
export default __webpack_public_path__ + "static/media/videoimg.80abb968cb8b7009353fde4e3894259d.svg";
export { ForwardRef as ReactComponent };